<template>
  <div>
    <Header
      :history="history"
      :data="drawerData"
      :action="action"
      @goBack="goBack"
      @close="close"
    />

    <transition name="fade">
      <div v-if="isSuccess" :style="`height: ${contentHeight}px`">
        <div v-if="hasRole('billing', 'ROLE_GET_FINANCIAL_ACCOUNT_PAYMENT_METHOD')">
          <Preview
            v-if="action !== 'edit'"
            :data="drawerData"
            @change="change"
            @close="close"
          />
        </div>

        <EmptyState
          v-else
          image="employee"
          :imageSize="120"
          class="px-4"
        >
          <span class="state__text">{{ $t('Views.ReportsPage.withoutPermission') }}</span>
        </EmptyState>
      </div>
    </transition>

    <div
      v-if="isLoading"
      class="progress__wrapper text-xs-center py-5"
      :style="`height: ${contentHeight}px`"
    >
      <div class="progress">
        <v-progress-circular indeterminate color="primary" />
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import { STATUS_IS_LOADING, STATUS_SUCCESS, STATUS_FAILED } from 'utils/constants'
import { hasRole } from 'utils/functions'
import { calcContentHeight, catchError } from 'corp-front-vue-commons/src/utils/functions'
import Header from './Header'
import Preview from './Preview'
import EmptyState from 'components/EmptyState'

export default {
  name: 'TimePolicy',
  props: {
    data: {
      type: Object,
      default: () => {}
    },

    actionType: {
      type: String,
      default: 'preview'
    },

    history: {
      type: Array,
      default: () => []
    },

    drawerType: {
      type: String,
      required: true
    }
  },
  components: {
    Header,
    Preview,
    EmptyState
  },
  computed: {
    ...mapState({
      company: ({ company }) => company.selectedCompany
    }),

    isLoading () {
      return this.currentStatus === STATUS_IS_LOADING
    },

    isSuccess () {
      return this.currentStatus === STATUS_SUCCESS
    },

    isFailed () {
      return this.currentStatus === STATUS_FAILED
    }
  },
  data () {
    return {
      currentStatus: null,
      drawerData: {},
      contentHeight: 'none',
      action: 'preview'
    }
  },
  methods: {
    hasRole (group, role) {
      return hasRole(group, role)
    },

    calcContentHeight () {
      this.contentHeight = calcContentHeight()
    },

    goBack () {
      this.$emit('goBack')
    },

    close (reload) {
      this.action = 'preview'
      this.$emit('close', reload)
    },

    change (val) {
      this.$emit('change', val)
    },

    async loadData () {
      this.currentStatus = STATUS_IS_LOADING

      try {
        this.drawerData = {
          ...this.data
        }

        this.$emit('updateHistory', {
          drawerType: 'timePolicy',
          data: this.data
        })

        this.currentStatus = STATUS_SUCCESS
      } catch (error) {
        catchError(error)
        this.currentStatus = STATUS_FAILED
      }
    }
  },
  watch: {
    data: {
      deep: true,
      handler (val) {
        this.loadData()
      }
    },

    company () {
      this.close()
    }
  },
  mounted () {
    this.calcContentHeight()
    window.addEventListener('resize', this.calcContentHeight)
    this.loadData()
  },
  beforeDestroy () {
    window.addEventListener('resize', this.calcContentHeight)
  }
}
</script>

<style lang="scss" scoped>
.progress__wrapper {
  position: relative;
}

.progress {
  left: 50%;
  position: absolute;
  top: 50%;
  transform: translate(-50%, -50%)
}
</style>
